// extracted by mini-css-extract-plugin
export default {"container":"mf2LWneMI3Z4MGYaTM29","header":"AINLozy33DfJ_qnXPp0j","title":"lCcXa3BiHaGKtYMDUfkF","wasDiceUnfair":"XqMkGnf3arWPZNVRUFc9","grayBar":"V4jj25aioG9HpD4BuvXs"};